/*eslint-disable */
export function getAllCredits(state) {
    return state.allSorted || [];
}

export function getApprovedCredits(state) {
    return state.approvedSorted || [];
}

export function getUnderReviewCredits(state) {
    return state.underReviewSorted || [];
}

export function getDeniedCredits(state) {
    return state.deniedSorted || [];
}
export function getCancelledCredits(state) {
    return state.cancelledSorted || [];
}
export function getFilter(state) {
    return state.filter;
}

export function getSearchIndexById(state) {
    return state.searchIndexById || {};
}

export function getCreditAllCurrentPage(state) {
    return state.creditAllCurrentPage;
}

export function getCreditUnderCurrentPage(state) {
    return state.creditUnderCurrentPage;
}

export function getCreditApprovedCurrentPage(state) {
    return state.creditApprovedCurrentPage;
}

export function getCreditDeniedCurrentPage(state) {
    return state.creditDeniedCurrentPage;
}
export function getCreditCancelledCurrentPage(state) {
    return state.creditCancelledCurrentPage;
}
export function getPerPage(state) {
    return state.perPage;
}
export function getIsNeedUpdate(state) {
    return state.isNeedUpdate;
}

export function creditsFromUpdate(state) {
    return state.creditsFromUpdate;
}

